import React, { Component } from 'react';
import ReactTooltip from "react-tooltip";
import Rating from 'react-star-rating-component';
import { CommentsNew } from '../Banner/commentsnew';
class CommunityReview extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            authe: false,
            rate: 0,
            noofreview: 0,
            rating: {},
            user_type: 1,
            commentParm: {}
        };
    }
    componentDidMount() {
        console.log('review partner_type', this.props);
        let data_auth = (localStorage.getItem("myData"));
        let userid;
        if (data_auth) {
            let auth_data = JSON.parse(data_auth)
            this.setState({
                logged_name: auth_data.first_name + ' ' + auth_data.last_name,
                authe: true,
                user_id: auth_data.user_id,
            });
        }
        this.setState({
            commentParm: this.props.data.commentParm,
            noofreview: this.props.data.noofreview,
            rate: this.props.data.rate,
            rating: this.props.data.rating,
            user_type: this.props.data.user_type,
        })
    }
    onTrigger = (event) => {
        event.preventDefault();
        this.props.callBackLogin();
    }
    triggerReview = () => {
        document.getElementById("review-btn").click();
    }
    render() {
        console.log('this.state.authe', this.state.authe);
        const { user_type, rate } = this.state;
        return (
            <div className='col-md-12  n5v3k'>
                <div className='n8b4fx'>
                    <div className="box-shadow-custom reviews-bottom-ratings">
                        <h3 className='m0v4xd pointer' onClick={this.triggerReview}>Reviews</h3>
                        <div className="ratings-star">
                            <h6>{rate != 'NaN' ? rate : '0.0'} </h6>
                            {
                                this.state.noofreview > 0 &&
                                (

                                    <p>
                                        <i class="fa fa-info-circle" data-tip data-for="rating-detail-tip"></i>
                                        <ReactTooltip id="rating-detail-tip" place="bottom" effect="solid" className='react_tooltip_backgrnd'>
                                            ( Number of People Reviewed <b>{this.state.noofreview}</b> )
                                        </ReactTooltip>
                                    </p>

                                )
                            }
                            <Rating
                                starCount={5}
                                value={rate != 'NaN' ? rate : '0.0'}
                            // onStarClick={this.onStarClick.bind(this)}
                            />
                        </div>

                        <div className='entry-colors'>
                            <div className='colo_col_1'></div>
                        </div>

                        <div className='col-md-12 n6-desc'>
                            <div className='row'>
                                
                                <div className='col-md-4'>
                                    <div className='type-n7ngd'>{user_type == 1 ? 'Counsellor' : 'Comfort with Trainer / Teacher'} </div>
                                    <div className='key-po'>{this.state.rating.qty_teachers != 'NaN' ? this.state.rating.qty_teachers : '0.0'}</div>
                                </div>
                                <div className='col-md-4'>
                                    <div className='type-n7ngd'>{user_type == 1 ? 'Counselling' : 'Method of Teaching / Coaching / Counselling'}</div>
                                    <div className='key-po'>{this.state.rating.qty_teaching != 'NaN' ? this.state.rating.qty_teaching : '0.0'}</div>
                                </div>
                                <div className='col-md-4'>
                                    <div className='type-n7ngd'>Child Safety</div>
                                    <div className='key-po'>{this.state.rating.child_safety != 'NaN' ? this.state.rating.child_safety : '0.0'}</div>
                                </div>

                                <div className='col-md-4'>
                                    <div className='type-n7ngd'>{user_type == 1 ? 'Facilities & Connectivity' : 'Quality of Connectivity / Campus'}</div>
                                    <div className='key-po'>{this.state.rating.facilities != 'NaN' ? this.state.rating.facilities : '0.0'}</div>
                                </div>

                                <div className='col-md-4'>
                                    <div className='type-n7ngd'>{user_type == 1 ? 'Ontime / Punctuality' : 'Punctuality'}</div>
                                    <div className='key-po'>{this.state.rating.ontime_punctuality != 'NaN' ? this.state.rating.ontime_punctuality : '0.0'}</div>
                                </div>
                                <div className='col-md-4'>
                                    <div className='type-n7ngd'>{user_type == 1 ? 'Information @ Website' : 'Ease of Interaction'}</div>
                                    <div className='key-po'>{this.state.rating.qty_intraction != 'NaN' ? this.state.rating.qty_intraction : '0.0'}</div>
                                </div>
                                <div className='col-md-4'>
                                    <div className='type-n7ngd'>Overall Rating</div>
                                    <div className='key-po'>{this.state.rating.overall_expirence != 'NaN' ? this.state.rating.overall_expirence : '0.0'}</div>
                                </div>
                                <div className='col-md-12 mt-3'>
                                    <div className=''>Note : Review options are enabled based on the teaching location</div>
                                </div>
                                <div className='col-md-4'></div>
                                {(this.state.authe === false) ?
                                    <div className="col-md-12 " onClick={this.onTrigger}>
                                        <div class="col-md-8  detailBox">
                                            <div className="form-comments">
                                                <p style={{ textAlign: 'center' }}>Click here to view Comments!...</p>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <span className="col-md-12">
                                        <CommentsNew paramId={this.state.commentParm} />

                                    </span>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export { CommunityReview };